



















































































import Vue from 'vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import slugify from 'slugify';
import api from '@/common/api';
import { BasicProcessor, Processor } from '@/common/types/processors.types';
import { initValidationErrors, ValidationErrors } from '@/common/validation/validation.types';
import { PaymentType } from '@/common/types/payments.types';
import { initDefaultHppConfig } from '@/common/util/hostedPaymentPages.util';
import { HostedPaymentPageTypes } from '@/common/types/hostedPaymentPages.types';
import ProcessorSelector from '../components/hosted-payments/ProcessorSelector.vue';
import HostedPaymentAmount from '../components/hosted-payments/HostedPaymentAmount.vue';
import { Plan } from '../plans/plans.types';

export default Vue.extend({
  props: {
    hppItemToEdit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PaymentType,
      HostedPaymentPageTypes,
      hppWriteModel: {
        name: '',
        description: '',
        redirect: null,
        achProcessorId: '',
        creditCardProcessorId: '',
        amount: 0,
        isFixedAmount: false,
        config: initDefaultHppConfig(),
        slug: '',
        isRecurring: false,
        planId: null,
      },
      hppItemId: '' as string,
      isSubmitting: false as boolean,
      showModal: false as boolean,
      isLoading: false as boolean,
      availableProcessors: [] as BasicProcessor[],
      availablePlans: [] as Plan[],
      selectedProcessor: null as Processor | null,
      validationErrors: initValidationErrors() as ValidationErrors,
      chosenHppType: '' as string,
      hppPaymentTypes: [
        {
          display: HostedPaymentPageTypes.STANDARD,
          value: HostedPaymentPageTypes.STANDARD,
        },
        {
          display: HostedPaymentPageTypes.RECURRING,
          value: HostedPaymentPageTypes.RECURRING,
        },
        {
          display: HostedPaymentPageTypes.FIXED_AMOUNT,
          value: HostedPaymentPageTypes.FIXED_AMOUNT,
        },
      ],
    };
  },
  watch: {
    hppItemToEdit() {
      this.hppItemId = this?.hppItemToEdit.id;
    },
    hppItemId() {
      this.loadHppData();
    },
  },
  mounted() {
    this.loadAvailableProcessors();
    this.loadAvailablePlans();
  },
  methods: {
    loadHppData() {
      if (this?.hppItemId === undefined || this?.hppItemId === '') return;

      api
        .get(`/hosted-payments/${this.hppItemId}`)
        .then(({ data: { data } }) => {
          this.hppWriteModel.name = data.name;
          this.hppWriteModel.description = data.description;
          this.hppWriteModel.redirect = data.redirect;
          this.hppWriteModel.achProcessorId = 'ach' in data?.processors ? data?.processors?.ach.id : null;
          this.hppWriteModel.creditCardProcessorId = 'credit' in data?.processors ? data?.processors?.credit.id : null;
          this.hppWriteModel.amount = data?.amount;
          this.hppWriteModel.isFixedAmount = data?.isFixedAmount;
          this.hppWriteModel.slug = data?.slug;
          this.hppWriteModel.config = data?.config;
          this.hppWriteModel.isRecurring = data?.isRecurring;
          this.hppWriteModel.planId = data?.plan?.uuid;
          this.isLoading = false;
          this.showModal = true;
          this.setChosenHppTypeRead();
        })
        .catch(() => {
          this.$toasted.error('Problem loading hpp information');
        });
    },
    loadAvailableProcessors() {
      if (this.showModal) {
        this.submitActions(true);
      }
      api
        .get('processors')
        .then(this.setAvailableProcessors)
        .catch(this.handleError)
        .finally(() => this.submitActions(false));
    },
    loadAvailablePlans() {
      api
        .get('/plans')
        .then(this.setAvailablePlans);
    },
    sluggifyForSubdomain(value: string): any {
      this.hppWriteModel.slug = slugify(value, {
        lower: true,
        strict: true,
      });
    },
    handleError() {
      this.$toasted.error('There was a problem loading available processors');
    },
    setAvailableProcessors({ data: { data } }: { data: { data: BasicProcessor[] } }) {
      this.availableProcessors = data;
    },
    setAvailablePlans({ data: { data } }: { data: { data: any } }) {
      this.availablePlans = data;
    },
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    reset() {
      this.selectedProcessor = null;
      this.validationErrors = {};
    },
    show() {
      this.hppItemId = this?.hppItemToEdit.id;
      this.isLoading = true;
      this.showModal = false;
    },
    close() {
      this.showModal = false;
      this.submitActions(false);
      this.hppItemId = '';
      this.reset();
    },
    onCreated() {
      this.$emit('created');
      this.close();
    },
    saveHpp() {
      if (!this.isValid) {
        return;
      }
      this.submitActions(true);
      this.setChosenHppTypeWrite();

      api
        .put(`/hosted-payments/${this.hppItemId}`, this.hppWriteModel)
        .then(() => {
          this.close();
          this.$emit('created');
          (this.$refs.form as any).reset();
        })
        .catch(({ response }: { response: any }) => {
          this.submitActions(false);
          if (response.status === 422) {
            const errors = response?.data?.errors;
            let msg: any = '';
            Object.keys(errors).forEach((key: any, idx: any) => {
              if (idx > 0) msg += '<br />';
              msg += `${errors[key]}`;
            });
            this.$toasted.error(msg);
          } else {
            this.$toasted.error(`There was
      a problem creating the merchant. (${response.status})`);
          }
          this.validationErrors = response.data.errors || {};
        });
    },
    setChosenHppTypeRead() {
      if (this.hppWriteModel.isFixedAmount) {
        this.chosenHppType = HostedPaymentPageTypes.FIXED_AMOUNT;
      }
      if (this.hppWriteModel.isRecurring) {
        this.chosenHppType = HostedPaymentPageTypes.RECURRING;
      }
      if (!this.hppWriteModel.isRecurring && !this.hppWriteModel.isFixedAmount) {
        this.chosenHppType = HostedPaymentPageTypes.STANDARD;
      }
    },
    setChosenHppTypeWrite() {
      if (this.hppWriteModel.planId !== null) {
        this.hppWriteModel.isRecurring = true;
      }
      if (this.chosenHppType === HostedPaymentPageTypes.STANDARD) {
        this.hppWriteModel.isFixedAmount = false;
        this.hppWriteModel.isRecurring = false;
      } if (this.chosenHppType === HostedPaymentPageTypes.FIXED_AMOUNT) {
        this.hppWriteModel.isRecurring = false;
        this.hppWriteModel.isFixedAmount = true;
      } if (this.chosenHppType === HostedPaymentPageTypes.RECURRING) {
        this.hppWriteModel.isFixedAmount = false;
        this.hppWriteModel.isRecurring = true;
      }
    },
    setFixedAmount(fixedAmount: number) {
      this.hppWriteModel.amount = fixedAmount;
    },
  },
  computed: {
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    hppUrl(): string {
      return `${window.location.origin}/pay/`;
    },
    planDescription(): string {
      if (this.hppWriteModel.planId) {
        const plan = this.availablePlans.find((p) => p.id === this.hppWriteModel.planId);
        return `$${plan?.amount! / 100} ${plan?.recurrenceText}`;
      }
      return '';
    },
  },
  components: {
    LoadingModal,
    ProcessorSelector,
    HostedPaymentAmount,
  },
});
